export default __webpack_public_path__ + "static/media/tick.6fa55d33.svg";